import { CustomAxios, getResponseData } from 'redux/axios';
import {
  ListRegisteredServicesResponse,
  ListMigrationsResponse,
  Migration,
  ListServicesResponse,
} from '@weave/schema-gen-ts/dist/schemas/organization/merge/coordinator/v1/api.pb';
import {
  Org,
  SearchOrgsResponse,
  SearchOrgsRequest_SearchEntity,
} from '@weave/schema-gen-ts/dist/apis/api/identity/v1/api.pb';
import { REACT_APP_API_SCHEMAS_URL } from '../../config/app';

const BASE_URL = '/organization/merge/coordinator/v1';
const IDENTITY_BASE_URL = REACT_APP_API_SCHEMAS_URL;

export const listRegisteredServices =
  async (): Promise<ListRegisteredServicesResponse> => {
    const response = await CustomAxios.get(`${BASE_URL}/registered-services`);
    return getResponseData(response);
  };

export const listMigrations = async (
  pageSize?: string,
  pageToken?: string
): Promise<ListMigrationsResponse> => {
  const response = await CustomAxios.get(`${BASE_URL}/migrations`, {
    params: {
      pageSize,
      pageToken,
    },
  });
  return getResponseData(response);
};

export const getMigrationDetails = async (migrationId: string): Promise<Migration> => {
  const response = await CustomAxios.get(`${BASE_URL}/migrations/${migrationId}`);
  return getResponseData(response);
};

export const listServices = async (
  migrationId: string
): Promise<ListServicesResponse> => {
  const response = await CustomAxios.get(
    `${BASE_URL}/migrations/${migrationId}/services`
  );
  return getResponseData(response);
};

export const getOrgInfo = async (orgId: string): Promise<Org> => {
  const response = await CustomAxios.get(`/identity/v1/orgs/${orgId}`, {
    baseURL: IDENTITY_BASE_URL,
  });
  return getResponseData(response);
};

export const searchOrgs = async (query: string): Promise<SearchOrgsResponse> => {
  const response = await CustomAxios.get(`/identity/v1/orgs:search`, {
    baseURL: IDENTITY_BASE_URL,
    params: { query, searchEntity: SearchOrgsRequest_SearchEntity.ORG },
  });
  return getResponseData(response);
};

export const createMigration = async (
  sourceOrgId: string,
  destinationOrgId: string
): Promise<Migration> => {
  const response = await CustomAxios.post(`${BASE_URL}/migrations`, {
    sourceOrgId,
    destinationOrgId,
  });
  return getResponseData(response);
};

export const retryMigration = async (migrationId: string): Promise<void> => {
  await CustomAxios.post(`${BASE_URL}/migrations/${migrationId}:retry`, {
    migrationId,
  });
};

export const rollbackMigration = async (migrationId: string): Promise<void> => {
  await CustomAxios.post(`${BASE_URL}/migrations/${migrationId}:rollback`, {
    migrationId,
  });
};
